<template>
  <user-form></user-form>
</template>
<script>
import UserForm from "../User/CreateForm.vue";
export default {
  components: {
    UserForm
  }
};
</script>
